import apiClient from './apiClient';

const API_URL = '/tramites/reconocimiento';

// Listar / filtrar trámites de Reconocimiento de Servicios
export const getTramitesReconocimiento = async (idCliente = null, subtipo = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (subtipo && subtipo.trim() !== '') params.subtipo = subtipo;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite (incluye checklist)
export const getTramiteReconocimientoById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite de Reconocimiento de Servicios
export const crearTramiteReconocimiento = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de Reconocimiento de Servicios:', error.response?.data || error.message);
        throw error;
    }
};

// Preview en vivo del checklist de formularios (función pura del backend, condicional por subtipo)
export const getChecklistFormularios = async ({ subtipo, tieneRelacionEmpleador }) => {
    const params = { subtipo };
    if (tieneRelacionEmpleador) params.tieneRelacionEmpleador = true;

    const response = await apiClient.get(`${API_URL}/formularios`, { params });
    return response.data;
};

// Editar datos del trámite (no el cliente). Puede devolver 409 con { requiereConfirmacion, items }
// si el cambio de subtipo/tieneRelacionEmpleador quita del checklist un formulario ya adjuntado.
export const actualizarTramiteReconocimiento = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable con firma)
export const actualizarComentariosReconocimiento = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Actualizar un ítem del checklist (marcar presentado / adjuntar archivo)
export const actualizarChecklistItem = async (idItem, { presentado, idArchivo }) => {
    const response = await apiClient.patch(`${API_URL}/formularios/${idItem}`, { presentado, idArchivo });
    return response.data;
};

// Reconocimientos vinculados a un trámite padre (Jubilación o Plan de Pago), para su card
export const getReconocimientosPorPadre = async (idTramitePadre) => {
    const response = await apiClient.get(API_URL, { params: { idTramitePadre } });
    return response.data;
};

// Guardar la resolución del reconocimiento. El dto lleva el total de servicios reconocidos
// (aniosReconocidos / mesesReconocidos / diasReconocidos), cuantoFalta (manual),
// resultadoResolucion, fechaResolucion, observacionesResolucion e idArchivoResolucion.
export const guardarResolucionReconocimiento = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}/resolucion`, dto);
    return response.data;
};

const reconocimientoService = {
    getTramitesReconocimiento,
    getTramiteReconocimientoById,
    crearTramiteReconocimiento,
    getChecklistFormularios,
    actualizarChecklistItem,
    actualizarTramiteReconocimiento,
    actualizarComentariosReconocimiento,
    getReconocimientosPorPadre,
    guardarResolucionReconocimiento,
};

export default reconocimientoService;
